export default __webpack_public_path__ + "static/media/Lifeproof.683a13bb.svg";